"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalSchoolGroupType = void 0;
// Used by the UK Government GIAS files in the "Group Type" column
// https://www.get-information-schools.service.gov.uk/Downloads
var ExternalSchoolGroupType;
(function (ExternalSchoolGroupType) {
    ExternalSchoolGroupType["MAT"] = "Multi-academy trust";
})(ExternalSchoolGroupType = exports.ExternalSchoolGroupType || (exports.ExternalSchoolGroupType = {}));
//# sourceMappingURL=SyncSchoolGroups.js.map